import * as React from 'react';
import styles from './index.less';
import { RefSelectProps, SelectProps } from 'antd/lib/select';
import { Select } from 'antd';

interface FSelect2Props extends SelectProps {}

function FSelect2({ ...props }: FSelect2Props, ref: React.Ref<RefSelectProps> | undefined) {
  return (
    <Select
      {...props}
      className={[props.className || '', styles.FSelect2].join(' ')}
      popupClassName={[props.popupClassName || '', styles.popupClassName].join(' ')}
      options={props.options?.map((option) => {
        return {
          ...option,
          className: styles.optionClassName,
        };
      })}
    />
  );
}

export default React.forwardRef(FSelect2);
